var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{staticStyle:{"min-height":"500px"}}),_vm._v(" "),_c('footer',{staticStyle:{"background":"rgba(255,255,255,1)","box-shadow":"0px -1px 0px 0px rgba(229,229,229,1)"}},[_c('HomeFooter')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0779c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/main.vue
// module id = null
// module chunks = 